import { ReactNode, useState } from "react";
import { ViewTitleSetterContext, ViewTitleValueContext } from "./context";

export const ViewTitleProvider = (props: {
  children: ReactNode;
}): JSX.Element => {
  const [viewTitle, setViewTitle] = useState<string | null>(null);

  // setViewTitle is referentially stable across renders, so consumers of the
  // setter context never re-render when the title changes — only the value
  // consumer (TopHeader) does.
  return (
    <ViewTitleSetterContext.Provider value={setViewTitle}>
      <ViewTitleValueContext.Provider value={viewTitle}>
        {props.children}
      </ViewTitleValueContext.Provider>
    </ViewTitleSetterContext.Provider>
  );
};
